"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorBasedOnBackground = exports.debounce = exports.retry = exports.isUrlPrivate = exports.Uuid = void 0;
const MathUtils_1 = require("three/src/math/MathUtils");
exports.Uuid = {
    /**
     * Regular expression to check if string is a valid UUID
     * @param uuid
     * @returns
     */
    isValid(uuid) {
        const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
        return regexExp.test(uuid);
    },
    /**
     * Generate random uuid
     * @returns
     */
    generate() {
        return (0, MathUtils_1.generateUUID)().toLowerCase();
    }
};
function isUrlPrivate(url) {
    const needle = "/private/";
    const dummyUrl = "https://dummy.si";
    return (new URL(dummyUrl + url).pathname.indexOf(needle) !== -1);
}
exports.isUrlPrivate = isUrlPrivate;
function retry(func, delay) {
    let success = false;
    let interval;
    (function () {
        interval = setInterval(() => {
            //@ts-ignore
            success = func.apply(this, arguments);
            if (success)
                clearInterval(interval);
        }, delay);
    })();
}
exports.retry = retry;
function debounce(func, delay) {
    let timeout;
    return function () {
        //@ts-ignore
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
    };
}
exports.debounce = debounce;
function colorBasedOnBackground(bgColor) {
    const r = parseInt(bgColor.substring(1, 3), 16);
    const g = parseInt(bgColor.substring(3, 5), 16);
    const b = parseInt(bgColor.substring(5, 7), 16);
    // YIQ ratio
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000000' : '#ffffff';
}
exports.colorBasedOnBackground = colorBasedOnBackground;
